import React from 'react'

import {
  getEntity,
  getHeaderData,
  getFooterData,
  getQuotationPageData,
} from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeArchiveProductsFinancial } from '@models/ArchiveProductsFinancial'
import { default as normalizeArchiveFunds } from '@models/ArchiveFunds'
import normalizeMetadata from '@models/Metadata'

import Breadcrumb from '@/molecules/Breadcrumb'
import { ProductsFinancialList, SectionBuilder } from '@/organisms'

import Layout from '@/organisms/Layout'

export const getServerSideProps = async () => {
  const [header, footer, pageData, productsFinancial, funds] =
    await Promise.all([
      getHeaderData(),
      getFooterData(),
      getQuotationPageData(),
      getEntity({ entity: 'productsFinancial', baseUrlEndpoint: 'proxy' }),
      getEntity({ entity: 'funds', baseUrlEndpoint: 'proxy' }),
    ])

  return {
    props: {
      metadata: normalizeMetadata(pageData.seo),
      breadcrumb: normalizeBreadcrumb([{ label: 'Quotazioni' }]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      sections: pageData?.sections ? pageData.sections : null,
      productsFinancial: normalizeArchiveProductsFinancial({
        products: productsFinancial.body,
        funds: funds.body,
      }),
      funds: normalizeArchiveFunds(funds.body),
      fundFooterInfo: [
        {
          id: 'quotationsFooterInfo',
          type: 'RichText',
          paragraph: {
            as: 'p',
            typo: 'paragraph2',
            content:
              '<em>Tutte le quotazioni mostrate dei fondi interni (es. valore prudente, bilanciato, ponderato, dinamico) si riferiscono all’ultima valorizzazione disponibile; per ogni operazione disposta sul fondo è comunque necessario fare riferimento alle date indicate nel Set Informativo.</em>',
          },
          align: 'center',
          space: 'md',
          theme: 'white',
        },
      ],
    },
  }
}

const ArchiveProductsFinancial = ({
  metadata,
  header,
  footer,
  breadcrumb,
  sections,
  productsFinancial,
  funds,
  fundFooterInfo,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='white'
    >
      <Breadcrumb items={breadcrumb} />
      {sections ? <SectionBuilder data={sections} /> : null}
      <ProductsFinancialList
        {...productsFinancial}
        fundSearch={funds.fundSearch}
      />
      <SectionBuilder data={fundFooterInfo} />
    </Layout>
  )
}

export default ArchiveProductsFinancial
